/* eslint-disable react-hooks/exhaustive-deps */
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { contractService } from '../../utils/helpers/observer';
import { Toast } from 'primereact/toast';
import { loaderDataComponent } from '../../utils/helper';
import RenderTableDatas from '../../components/module/table/renderTableDatas';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import AutocompleteComponent from '../../components/common/component/AutocompleteComponent';
import { PopupComponent } from '../../utils/helpers/table/tableHelper';
import ReactDOM from 'react-dom';
import { createBlob, prepareDataToSend } from '../../utils/helpers/table/exportTableHelper';
import { ExportTableApi } from '../../utils/api';
import moment from 'moment';
import { filterUserTable } from '../../utils/helpers/administration/rightsUserHelper';
import PopupUser from '../../Views/administration/userView/PopupUser';
import { UserContext } from './AdministrationView';
import { createRoot } from 'react-dom/client';

interface UserResponse {
  Username: string;
  Enabled: boolean;
  FirstName: string;
  LastName: string;
  Email: string;
  EmailVerified: boolean;
  Role: string;
}


const RightsUsers = () => {
  const adminstrationViewContext = useContext(UserContext);
  // loading state
  const [loading, setLoading] = useState<boolean>(false);
  const [userSelected, setUserSelected] = useState<any>(null);
  const [dataTable, setDataTable] = useState<any[]>([]);
  // toast
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);

  // component did mount
  useEffect(() => {
    contractService.setContract(
      window.sessionStorage.getItem('contractCode') || '',
    );
  }, []);

  useEffect(() => {
    adminstrationViewContext.userData.length > 0 && setDataTable(adminstrationViewContext.userData.map((user: any) => ({
        id: user.id,
        email: user.email,
        role: user.role,
        enabled: user.enabled,
        firstName: user.firstName,
        lastName: user.lastName,
        getUsersUpdated: adminstrationViewContext.getUsers,
    })));
  }, [adminstrationViewContext.userData]);

  useEffect(() => {
      setLoading(adminstrationViewContext.loading);
  }, [adminstrationViewContext.loading]);

  const applyFiltersOnTable = () => {
    const filteredData = filterUserTable(adminstrationViewContext.userData, userSelected);
    setDataTable(
      filteredData.map((user: any) => ({
        id: user.id,
        email: user.email,
        role: user.role,
        enabled: user.enabled,
        firstName: user.firstName,
        lastName: user.lastName,
        roleType: user.roleType,
      }))
    );
  };

  useEffect(() => {
    adminstrationViewContext.userData.length > 0 && applyFiltersOnTable();
  }, [userSelected]);

  const breakLine = () => {
    return (
      <hr
        style={{
            backgroundColor: '#DCDCDC',
            width: '100%',
            marginTop: '10px',
            marginBottom: '10px',
            height: '1px',
        }}
      />
    );
  };

  const addNewUser = () => {
    // Logic to add a new user
    const node = document.createElement('divAdminUsersAddUser');
    document.body.appendChild(node);
    const root = createRoot(node!);
    root.render(
      <PopupComponent
        tagName='divAdminUsersAddUser'
        content={<PopupUser view='add' getUsersUpdated={adminstrationViewContext.getUsers} />}
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          background: '#fff',
          borderRadius: '14px',
          padding: '20px',
          border: '1px solid #999',
          width: '30%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    );
  };

  const mapToUserResponse = (item: any): UserResponse => ({
    Username: item.username ?? '',
    Enabled: item.enabled ?? false,
    FirstName: item.firstName ?? '',
    LastName: item.lastName ?? '',
    Email: item.email ?? '',
    EmailVerified: item.emailVerified ?? false,
    Role: item.role ?? ''
  });
  
  const generateUsersCsv = (users: UserResponse[]): string => {
    if (!Array.isArray(users) || users.length === 0) {
      return '';
    }
  
    const lines: string[] = [];
  
    lines.push('Prenom;Nom;Email;Active;EmailVerifie;Role');
  
    users.forEach(user => {
      lines.push(
        `${user.FirstName ?? ''};` +
        `${user.LastName ?? ''};` +
        `${user.Email ?? ''};` +
        `${user.Enabled};` +
        `${user.EmailVerified};` +
        `${user.Role ?? ''}`
      );
    });
  
    return lines.join('\n');
  };
  
  const exportTable = async () => {
    setLoading(true);
    
    try {
      const dataParam = prepareDataToSend(
        adminstrationViewContext.userData,
        'admin-users'
      );
  
      const body = JSON.stringify(dataParam);
  
      // ⬇️ FRONTEND CSV GENERATION (same logic as backend)
      const parsedBody = JSON.parse(body);
  
      if (!Array.isArray(parsedBody) || parsedBody.length === 0) {
        throw new Error('No users to export');
      }
  
      const mapped = parsedBody.map(mapToUserResponse);
  
      const filename =
        'utilisateurs-export-' +
        moment().utc().format('YYYY-MM-DD') +
        '.csv';
  
      createBlob('\uFEFF' + generateUsersCsv(mapped), filename);
  
      // ✅ success toast
      if (toastSucess.current) {
        toastSucess.current.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Tableau exporté avec succès.',
        });
      }
    } catch (error) {
      if (toastError.current) {
        toastError.current.show({
          severity: 'error',
          summary: 'Erreur',
          detail: "Échec de l'exportation du tableau.",
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container className='contractContainer'>
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      <Container
        className='contentContainer'
        style={{ width: '100%', height: '100%'}}
      >
        <div style={{ display: 'inline-flex' }}>
          <div style={{ justifyContent: 'start', display: 'inline-flex', width: '100%', alignItems: 'center' }}>
              <Word
                  value='Gestion des utilisateurs collectivités'
                  variant='span'
                  automatedTestId='contract-title'
                  textStyle='titleSmall'
                  className='contract-title'
              />
          </div>
          <div style={{ justifyContent: 'end', display: 'inline-flex', width: '100%' }}>
              <Button type='button' onClick={exportTable}>
                  <Word
                      value='Exporter le tableau'
                      variant='span'
                      automatedTestId='admin-export-users'
                      textStyle='normalReg'
                  />
              </Button>
              <Button type='button' onClick={addNewUser}>
                  <Word
                      value='Ajouter un utilisateur'
                      variant='span'
                      automatedTestId='admin-add-user'
                      textStyle='normalReg'
                  />
              </Button>
          </div>
        </div>
        {breakLine()}
        <div style={{ display: 'inline-flex', width: '100%', justifyContent: 'space-evenly' }}>
          <div style={{ width: '30%' }}>
              <AutocompleteComponent
                id='dropdownListUsers'
                Listoption={adminstrationViewContext.userData.map((c: any) => {
                    return { name: c.email, id: c.id };
                })}
                onChangeValue={(event, option: any) => {
                    if (option !== null) {
                      setUserSelected(option);
                    } else {
                      setUserSelected(null);
                    }
                }}
                placeholder='Choisir un utilisateur'
              />
          </div>
        </div>
        {breakLine()}
        <Card className='table_container'>
          <RenderTableDatas
            module={'admin-users'}
            dataDetail={[]}
            history={null}
            option={null}
            indicator={null}
            countIndicator={null}
            lengthIndicator={null}
            blackPoint={null}
            dataTable={dataTable}
            dataDate={null}
            prevFilters={null}
            roles={null}
            contractLabel={null}
            updateTableAndMap={null}
            zoomToPointTrigger={null}
          />
          </Card>
      </Container>
      <br />
      {loaderDataComponent(loading)}
    </Container>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style {
  color: black;
  .sds-m-card {
    box-shadow: none;
  }
  .contractContainer {    
    .contract-title {
      margin-top: 10px;
      text-align: center;
    }
    .contract-cancel {
      margin-top: 250px;
      text-decoration: underline;
    }
    .adminCpo {
      margin-bottom: 50px;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
      .dropdown-list {
        text-align: start;
        z-index: 50;
      }
    }
    .contentContainer {
      margin-left: auto;
      margin-right: auto;
    }
    .dropdown-list {
      z-index: 30;
    }
    .loaderContainer {
      margin-top: 0px;
    }
  }
}
`;
export default RightsUsers;
